import { Pipe, PipeTransform } from '@angular/core';

import { integracaoTiposExecucao } from '../integration-tipo-execucao';

@Pipe({
    name: 'integrationTipoExecucao'
})
export class IntegrationTipoExecucaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = integracaoTiposExecucao.findIndex(tipoExecucao => tipoExecucao.id === value);
        if (index > -1) {
            return integracaoTiposExecucao[index].nome;
        }
        return '';
    }
}
